import { Component, OnInit } from '@angular/core';
import { UIService } from '../shared/ui.service';
import { AuthService } from '../auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'environments/environment';
import { SvgMap } from 'app/shared/components/svg/uds-svg-map';
import { Utility } from '@dp/utilities';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FeedbackBannerService } from 'app/shared/components/feedback-banner/feedback-banner.service';
import { ChatbotService } from 'app/shared/components/chatbot/chatbot.service';
import { TranslateService } from '@ngx-translate/core';
import { Organization } from 'app/settings/users/users.model';
import { commonEnvironment } from 'environments/environment.common';

@UntilDestroy()
@Component({
  selector: 'dp-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
})
export class MainNavComponent implements OnInit {
  isExpanded = true;
  isHandset: boolean;
  isAuth: boolean;
  showSideNav: boolean;
  isFooterHide = true;
  SvgMap = SvgMap;
  showBanner: boolean;
  svgAttributes = {
    width: 24,
    height: 24,
  };
  showChatbot = false;
  org: Organization;
  constructor(
    private uiService: UIService,
    public authService: AuthService,
    private router: Router,
    private feedbackBannerService: FeedbackBannerService,
    private chatbotService: ChatbotService,
    public translate: TranslateService
    ) {
    window['dataLayer'] = window['dataLayer'] || [];
    const sidebarCollapse = Utility.getItem(environment.storage.sidebarCollapse, 'session');
    this.isExpanded = sidebarCollapse !== undefined ? !sidebarCollapse : this.isExpanded;
    this.org = this.authService.currentOrganizationValue;
  }

  ngOnInit(): void {
    this.feedbackBannerService.state$.subscribe(isBannerVisible => {
      this.showBanner = isBannerVisible;
    });
    this.uiService.isHandsetChanged.pipe(untilDestroyed(this)).subscribe((result) => (this.isHandset = result));
    this.authService.currentUser.pipe(untilDestroyed(this)).subscribe((user) => {
      let currentLang = 'en';
      if (user?.internalizationEnabled) {
        currentLang = Utility.getLocalStorageObject(commonEnvironment.storage.currentUserLang) || 'en';
      }
      this.translate.use(currentLang);
      this.isAuth = this.authService.isAuth();
    });
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // event is an instance of NavigationEnd, get url!
        const url = event.urlAfterRedirects;
        const cleanUrl = url.split('?')[0];
        this.isFooterHide = environment.onFooterHideRoutes.includes(cleanUrl);
        this.showChatbot = !environment.publicPageRoutes.includes(cleanUrl);
        const path = this.router.url;
        if (path.includes('_tracking') || path.includes('widget') || path.includes('documents'))
          this.chatbotService.updateState({ showChatBox: false, showChatBubble: false });
        else this.chatbotService.updateState({ showChatBox: false, showChatBubble: true });
        if (environment.publicPageRoutes.includes(cleanUrl)) {
          this.showBanner = false;
        }
        const routes = environment.noHeaderRoutes as string[];
        if (routes.find((route) => url.indexOf(route) > 0)) {
          this.showSideNav = false;
        } else {
          this.showSideNav = true;
        }
      }
    });
    if (this.isBannerVisible()) {
      Utility.generateAndTrackEventData(
        environment.gaEvents.names.bannerImpression,
        environment.gaEvents.categories.bannerImpression,
        environment.gaEvents.actions.feedbackBanner
      );
    }
  }

    get expandTooltip(): string {
    return this.translate.instant('sidenav.expand_txt');
  }

  isBannerVisible() {
    // Setting showG2Banner to false as part of User Story #262049
    // to remove the feedback banner globally for all users
    // Old implementation for reference:
    // return this.isAuth && 
    //   this.showBanner && 
    //   this.authService.currentUserValue.accountType === 'PREMIUM' && 
    //   this.authService.currentUserValue.g2Banner;
    return false;
  }

  toggleSideBar() {
    this.isExpanded = !this.isExpanded;
    Utility.setItem(environment.storage.sidebarCollapse, !this.isExpanded, 'session');
    this.trackEvent();
  }
  trackEvent() {
    window['dataLayer'].push({
      event: environment.gaEvents.names.navbar,
      eventDetail: {
        eventCategory: environment.gaEvents.categories.navBar,
        eventAction: environment.gaEvents.actions.hamburgerClick,
        isExpanded: this.isExpanded,
      },
    });
  }
}
